import { ApolloClient, InMemoryCache, ApolloLink, HttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getToken } from '../utils/getToken'
import { Auth } from 'aws-amplify'

const apiProducer = new HttpLink({
  uri: process.env.REACT_APP_API_PRODUCER + 'graphql',
})
const apiStore = new HttpLink({
  uri: process.env.REACT_APP_API_STORE + 'graphql',
})

const producerAuthLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('TOKEN_DASH')

  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  }
})

const apiProducerWithAuth = producerAuthLink.concat(apiProducer)

export const client = new ApolloClient({
  link: ApolloLink.split(
    (operation) => operation.getContext().clientName === 'apiProducer',
    apiProducerWithAuth,
    apiStore
  ),
  cache: new InMemoryCache(),
  ssrMode: typeof window === 'undefined',
})

export async function updateToken(newToken, forceRefresh = false) {
  const storedToken = newToken || localStorage.getItem('TOKEN_DASH')
  if (storedToken && !forceRefresh) return storedToken

  try {
    const authenticatedUser = await Auth.currentAuthenticatedUser()
    const sub = authenticatedUser?.attributes?.sub
    const email = authenticatedUser?.attributes?.email

    console.info('[ProducerAuth] Cognito user found', { email, hasSub: Boolean(sub) })

    if (!sub || !email) {
      throw new Error('Cognito user is missing required Producer auth attributes (sub or email)')
    }

    console.info('[ProducerAuth] Requesting Producer token', { email, hasSub: true })
    const token = await getToken(sub, email)

    if (typeof token !== 'string' || token.split('.').length !== 3 || token.split('.').some((part) => !part)) {
      throw new Error('Unable to obtain a valid Producer token')
    }

    localStorage.setItem('TOKEN_DASH', token)
    localStorage.setItem('TIME_TOKEN', new Date().toISOString())
    console.info('[ProducerAuth] TOKEN_DASH stored')

    return token
  } catch (error) {
    console.error('[ProducerAuth] Failed to obtain Producer token', error)
    throw error
  }
}

window.addEventListener('focus', async () => {
  const timeToken = localStorage.getItem('TIME_TOKEN') ? new Date(localStorage.getItem('TIME_TOKEN')) : null
  const timeCurrent = new Date().getTime()
  const timeElapsed = timeToken && Math.round((timeCurrent - timeToken.getTime()) / (1000 * 60))
  if (timeToken && timeElapsed >= 210) {
    try {
      await updateToken(null, true)
    } catch (error) {
      console.error('Error refreshing Producer token:', error)
    }
  }
})
